module.exports = __webpack_public_path__ + "img/basic-subscription.6040e1d4.jpg";